<h5 mat-dialog-title i18n>Select Print Options</h5>
<div mat-dialog-content>
  <p i18n>Select options for printing the quote or job.</p>
  <form #printOptionsForm="ngForm" (ngSubmit)="printQuote()">
    <div class="form-group row">
      <label for="quote_ContractNotes" class="col-sm-4 col-form-label" i18n>Contract Notes</label>
      <div class="col-sm-8">
        <textarea class="form-control" name="quote_ContractNotes" id="quote_ContractNotes"
                  rows="3"
                  [(ngModel)]="data.quote_ContractNotes" #quote_ContractNotes="ngModel">
        </textarea>
      </div>
    </div>
    <div>
      <mat-checkbox id="groupAreas" name="groupAreas" class="col-form-label" [(ngModel)]="groupAreas" i18n>Group Areas</mat-checkbox>
    </div>
    <div>
      <mat-checkbox id="showSquareFootage" name="showSquareFootage" class="col-form-label" [(ngModel)]="showSquareFootage" i18n>Show Square Footage</mat-checkbox>
    </div>
    <div *ngIf="showLinePricing">
      <mat-checkbox id="showPricing" name="showPricing" class="col-form-label" [(ngModel)]="showPricing" i18n>Show Item Pricing</mat-checkbox>
    </div>
    <div>
      <mat-checkbox id="showTaxes" name="showTaxes" class="col-form-label" [(ngModel)]="showTaxes" i18n>Show Tax</mat-checkbox>
    </div>
    <div class="form-group">
      <mat-checkbox id="hideItemNotes" name="hideItemNotes" class="col-form-label" [(ngModel)]="hideLineItemNotes" i18n>Hide Line Item Notes</mat-checkbox>
    </div>
    <div class="form-group">
      <select name="locale" class="form-control select-bidit" [(ngModel)]="locale">
        <option value="en">English</option>
        <option value="es">Español</option>
      </select>
    </div>
    <app-dealer-document-selection *ngIf="this.showDocuments || !documentsLoaded" (selectionUpdated)="documentSelectionUpdated($event)" (documentsLoaded)="loadDocuments($event)"></app-dealer-document-selection>
    <div class="form-group float-right">
      <button *ngIf="showPrintAttachments" mat-button type="button" (click)="showQuoteDocuments()" class="btn btn-outline-primary mr-1" i18n>Attach Documents</button>
      <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Print</button>
      <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
  </form>
</div>
